import type { CSSProperties } from 'react'
import { logger } from '../../utils/logger'
import {
  LayoutDashboard,
  Monitor,
  Users,
  User,
  Activity,
  FileText,
  ShieldCheck,
  Plus,
  Edit,
  Trash2,
  Eye,
  MoreVertical,
  Calendar,
  LockOpen,
  Lock,
  Shield,
  RefreshCw,
  RotateCcw,
  Download,
  Upload,
  Send,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  FileUp,
  X,
  LogOut,
  AlertTriangle,
  CircleAlert,
  CheckCircle,
  Lightbulb,
  Settings,
  Search,
  Check,
  Clock,
  Star,
  Cpu,
  Menu,
  VolumeX,
  DoorOpen,
  UsersRound,
  KeyRound,
  Sun,
  Moon,
  Timer,
  Cloud,
  Server,
  IdCard,
  EyeOff,
  CloudOff,
  ClipboardCheck,
  Building2,
  Mail,
  Headset,
  BadgeCheck,
  type LucideIcon,
} from 'lucide-react'

// Map Material Symbols names to Lucide icons
const iconMap: Record<string, LucideIcon> = {
  // Navigation
  dashboard: LayoutDashboard,
  devices: Monitor,
  people: Users,
  person: User,
  timeline: Activity,
  description: FileText,
  admin_panel_settings: ShieldCheck,
  menu: Menu,

  // Actions
  add: Plus,
  edit: Edit,
  delete: Trash2,
  visibility: Eye,
  more_vert: MoreVertical,
  schedule: Calendar,
  lock_open: LockOpen,
  lock: Lock,
  shield: Shield,
  sync: RefreshCw,
  restart_alt: RotateCcw,
  refresh: RefreshCw,
  download: Download,
  upload: Upload,
  send: Send,
  logout: LogOut,
  close: X,

  // Arrows
  chevron_right: ChevronRight,
  expand_more: ChevronDown,
  expand_less: ChevronUp,

  // Status/Misc
  warning: AlertTriangle,
  error: CircleAlert,
  check_circle: CheckCircle,
  lightbulb: Lightbulb,
  groups: Users,
  group: UsersRound,
  tune: Settings,
  settings: Settings,
  upload_file: FileUp,
  search: Search,
  check: Check,
  clock: Clock,
  star: Star,
  star_outline: Star,
  system_update: Cpu,
  volume_off: VolumeX,
  door_front: DoorOpen,
  key: KeyRound,
  sun: Sun,
  moon: Moon,
  timer: Timer,
  cloud: Cloud,
  dns: Server,
  badge: IdCard,
  eye_off: EyeOff,
  cloud_off: CloudOff,
  fact_check: ClipboardCheck,
  location_city: Building2,
  mail: Mail,
  support_agent: Headset,
  verified_user: BadgeCheck,
}

interface IconProps {
  name: string
  size?: number | string
  className?: string
  style?: CSSProperties
}

/**
 * Icon component using Lucide React icons
 * Maps Material Symbols names to Lucide equivalents
 */
export function Icon({ name, size = 24, className = '', style }: IconProps) {
  const LucideIcon = iconMap[name]

  if (!LucideIcon) {
    logger.ui.warn('icon not found', { icon_name: name })
    return null
  }

  const iconSize = typeof size === 'number' ? size : parseInt(size, 10) || 24

  return (
    <LucideIcon
      size={iconSize}
      className={className}
      style={style}
      strokeWidth={2}
    />
  )
}
